import React from "react";
import { Button, ButtonProps } from "@mui/material";

// An action button: solid blue (contained). Use for anything that performs an operation on the current
// page (analyse, recalibrate, sync, save, …). The action look lives here so it can be changed in one
// place. All the usual Button props pass through.
const ActionButton = ({ children, ...props }: ButtonProps) => (
  <Button variant="contained" {...props}>
    {children}
  </Button>
);

export default ActionButton;
